module.exports = __webpack_public_path__ + "img/checked-sources.be5ae72b.svg";